<script setup>
const props = defineProps({
    classWrapper: {
        type: String,
    },
});

// 遮罩滾動觸發
const scrollArea = ref(null);
const isBottom = ref(false);
const onScroll = () => {
    const el = scrollArea.value;
    if (!el) return;

    if (el.scrollTop + el.offsetHeight >= el.scrollHeight - 1) {
        isBottom.value = true;
    } else {
        isBottom.value = false;
    }
};

onMounted(() => {
    const hasScroll =
        scrollArea.value.scrollHeight > scrollArea.value.clientHeight;
    isBottom.value = !hasScroll;
});
</script>

<template>
    <section class="dialogue-container h-full">
        <div
            class="slt-scrollbar-hide dialogue-wrapper relative m-5 h-full max-h-[calc(0.87*var(--window-height))] w-fit overflow-hidden rounded-3xl sm:max-h-[calc(var(--window-height)-130px)] lg:m-0"
        >
            <div
                ref="scrollArea"
                @scroll="onScroll"
                class="slt-scrollbar-hide relative flex h-full items-start justify-center overflow-y-auto lg:items-center"
            >
                <slot />
            </div>
            <!-- 遮罩 -->
            <div
                style="
                    background: linear-gradient(
                        0deg,
                        #fff 0%,
                        rgba(255, 255, 255, 0) 100%
                    );
                "
                class="absolute bottom-0 z-10 h-[8.45vw] w-full lg:hidden"
                :class="{ hidden: isBottom }"
            ></div>
        </div>
    </section>
</template>

<style scoped>
.dialogue-container {
    @apply fixed inset-0 z-[3000] flex items-center justify-center bg-base-black-80;
}

.dialogue-wrapper {
    @apply max-w-[357px] sm:max-w-[452px] lg:max-w-[1330px];
}
</style>
